<template>
  <div class="player" :class="pages">

    <!--播放页面小屏 底部-->
    <div v-show="global.currUrl&&global.playerShow&&$route.path!='/video-play'&&$route.path!='/extend-login'&&$route.path!='/map'&&$route.path!='/study-activity'&&$route.path!='/download-list'&&$route.path!='/video-play-lz'&&$route.path!='/video-play-sm'
    &&$route.path!='/video-play-nx'&&$route.path!='/video-play-py'&&$route.path!='/video-play-lz1'&&$route.path!='/video-play-vr'&&$route.path!='/map-tour' && global.currBag && global.currBag.id">
      <div class="mini-player" @click="toVideoplay">
        <div class="icon">
          <img alt="" :src="global.currBag.guideheadimg2" :class="cdCls">
        </div>
        <div class="text">
          <h2 class="name hide">{{global.currVoice.spotname || global.currBag.bagname}}</h2>
          <p class="desc hide">{{global.currBag.name || global.currBag.bagname}}  /  {{global.currBag.guidename2}}</p>
        </div>
        <div class="control" @click.stop="playAudio">
          <img class="playimg" alt="" src="../assets/icon_main_play03.png" v-if="global.playing">
          <img class="playimg" alt="" src="../assets/icon_main_play02.png" v-else>
        </div>
        <div class="control" @click.stop="nextAudio">
          <img class="next" alt="" src="../assets/next.png" >
        </div>
      </div>

      <!--<audio :src="currentSong.currUrl" ref="audio" @play="ready" @error="error" @timeupdate="updateTime" @ended="ended"></audio>-->
      <audio id="Audio1" style="overflow: hidden" src="http://wangchuang-1252493175.coscd.myqcloud.com/jpjs/upload/voice/20181126/iosvoicetest.mp3"></audio>
    </div>
  </div>
</template>
<script>
  import {setStore, getStore, removeStore} from '@/config/mUtils'

  export default {
    data() {
      return {
        global: this.global,
      }
    },
    created() {

    },
    computed: {
      cdCls() {
        return this.global.playing ? 'play' : 'pause'
      },
      pages() {
        var cla
        if(this.$route.path == '/'||this.$route.path == '/user' ){
          cla = 'home'
        }else if(this.$route.path == '/view-detail-sm' || this.$route.path == '/spot-detail-sm'){
          cla = 'buddhism'
        }
        return cla
      },

    },
    methods:{
      //跳转到专辑详情页
      toVideoplay(){
        let appKey =  getStore("appKey") || "";
        if(appKey){
          appKey = appKey.appKey
        }
        if(this.global.shopStyle == 'pavilion'){
          this.$router.push({
            path: `/video-play-lz?${'id='+this.global.currBag.id+'&spotid='+this.global.currVoice.spotid+'&shopid='+this.global.currBag.shopid + '&appKey='+ appKey}`
          });
        }else if(this.global.shopStyle == 'buddhism'){
          this.$router.push({
            path: `/video-play-sm?${'id='+this.global.currBag.id+'&spotid='+this.global.currVoice.spotid+'&shopid='+this.global.currBag.shopid + '&appKey='+ appKey}`
          });
        }else if(this.global.shopStyle == 'nx'){
          this.$router.push({
            path: `/video-play-nx?${'id='+this.global.currBag.id+'&spotid='+this.global.currVoice.spotid+'&shopid='+this.global.currBag.shopid + '&appKey='+ appKey}`
          });
        }else if(this.global.shopStyle == 'py'){
          this.$router.push({
            path: `/video-play-py?${'id='+this.global.currBag.id+'&spotid='+this.global.currVoice.spotid+'&shopid='+this.global.currBag.shopid + '&appKey='+ appKey}`
          });
        }else {
          this.$router.push({
            path: `/video-play?${'id='+this.global.currBag.id+'&spotid='+this.global.currVoice.spotid+'&shopid='+this.global.currBag.shopid + '&appKey='+ appKey}`
          });
        }
      },

      playAudio(){
        if (this.global.Audio1.paused) {
          this.global.Audio1.play();

          this.global.set_playing(true)
        } else {
          this.global.Audio1.pause();
          if(this.global.videoTimer != null){
            clearInterval(this.global.videoTimer);
          }
          this.global.set_playing(false)
        }
      },

      nextAudio(){
        var currIndex = (this.global.currIndex == this.global.playList.length -1) ? 0 : (parseInt(this.global.currIndex) + 1);
        this.global.Audio1 = document.getElementById('Audio1');
        this.global.set_currVoice(this.global.playList[currIndex]);
        this.global.set_currIndex(currIndex);
        this.global.set_playing(true)
        this.global.set_currUrl(this.global.playList[currIndex].url);
        this.global.Audio1.src = this.global.playList[currIndex].url;
        this.global.Audio1.preload = "auto";
        this.global.Audio1.play();
      },

    }

  }
</script>
<style scoped>
  .player{ position: fixed; left: 0; right: 0; bottom: .1rem; z-index: 100; padding: 0 .24rem; }
  .player.home{ bottom: 1.2rem; }
  .player.buddhism{ bottom: 1.5rem; }
  .mini-player{ display: -ms-flexbox; display: flex; -ms-flex-align: center; align-items: center; width: 100%; height: 1.1rem; border-radius: .1rem; background: #7587ae;box-shadow: 0 10px 15px rgba(0,0,0,.4); }
  .mini-player .icon{ -ms-flex: 0 0 .88rem; flex: 0 0 .88rem; width: .88rem; height: .88rem; padding: 0 .18rem; }
  .mini-player .icon img { width: 100%; height: 100%; border-radius: 50%; object-fit: cover; }
  .mini-player .icon img.pause { animation-play-state: paused; }
  .mini-player .icon img.play{ animation: rotate 10s linear infinite; }
  @keyframes rotate{ 0%{transform: rotate(0);} 100%{transform: rotate(360deg);} }

  .mini-player .text{ display: -ms-flexbox; display: flex; -ms-flex-direction: column; flex-direction: column; -ms-flex-pack: center; justify-content: center; -ms-flex: 1; flex: 1; overflow: hidden; }
  .mini-player .text .name{ margin-bottom: .1rem; font-size: .25rem; font-weight: 600; color: #fff; }
  .mini-player .text .desc{font-size: .18rem; color: #bbc4c8; }
  .mini-player .control{ -ms-flex: 0 0 .9rem; flex: 0 0 .9rem; width: .9rem; }
  .mini-player .control .playimg{ width: .35rem; height: auto; }
  .mini-player .control .next{ width: .35rem; height: auto; }


</style>



// WEBPACK FOOTER //
// src/components/player.vue